import React, { Component } from 'react';
import { Nav, NavItem, NavLink, Navbar, Collapse, NavbarToggler, NavbarBrand } from 'reactstrap';
import { Link } from 'react-router-dom';
import { MenuItens, MenuItensAdministrativos } from './Menu.json';
import MenuXLSX from '../Componente/Common/MenuXLSX';
import MenuLinks from '../Componente/Common/MenuLinks';
import Feedback from '../Componente/Modais/Feedback';
import { ModalUploadContext } from '../Providers/ModalUpload';
import { BlockUiContext } from '../Providers/BlockUi';

import HttpUtil from '../Util/httpUtil';
import Config from '../Util/config';

import './MenuBar.scss';

const administrador = localStorage.getItem('Administrador') === 'true';
const vendas = localStorage.getItem('usuarioVendas') === 'true';

class MenuBar extends Component {
	constructor(props) {
		super(props);
		this.state = {
			setarMenu: '/',
			administrativoIsOpen: true,
			isOpen: false,
			numGuiasPendentes: 0,
			ultimoNumGuiasPendentes: 0,
		};
	}

	UNSAFE_componentWillMount = () => {
		this.BuscaTotalGuiasPendentes();
	};

	Mount = () => {
		window.location.pathname === '/feedback' && this.ModalFeedback.openModal();
	};

	Update = () => {
		const path = `/${window.location.pathname.split('/')[1] || 'pendentes'}`;
		if (this.state.setarMenu !== path) {
			this.setMenu(path);
		}

		// this.BuscaTotalGuiasPendentes();
	};

	setMenu = path => {
		this.setState({
			setarMenu: path,
		});
	};

	toggle = () => {
		setImmediate(() =>
			this.setState({
				administrativoIsOpen: !this.state.administrativoIsOpen,
				isOpen: !this.state.isOpen,
			}),
		);
	};

	abrirSuporteTecnico() {
		var url =
			'https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10';
		var win = window.open(url, '_blank');
		win.focus();
	}

	BuscaTotalGuiasPendentes() {
		HttpUtil.eco_GET(`${Config.urls.API_URL_BASE}Documento/BuscarPendentesCount`)
			.then(response => {
				const { data } = response;

				this.setState({
					numGuiasPendentes: data,
				});
			})
			.catch(() => {
				this.onLoading(false);
				this.setState({ rawData: [], showData: [], intDocumentos: 0 });
			});
	}

	render() {
		return (
			<aside id="menu-bar">
				<Feedback ref={modal => (this.ModalFeedback = modal)} />
				<ModalUploadContext.Consumer>
					{modalUpload => {
						this.openModalUpload = modalUpload.openModal;
					}}
				</ModalUploadContext.Consumer>
				<BlockUiContext.Consumer>
					{blockUi => {
						this.onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
				<Navbar expand="md" dark className="p-0 h-100">
					<NavbarBrand className="mr-auto">
						<img alt="" src="/img/logo-proj.png" />
					</NavbarBrand>
					<NavbarToggler onClick={this.toggle} />
					<Collapse isOpen={this.state.isOpen} navbar className="h-100">
						<Nav vertical={false} navbar>
							<NavItem className="mobile">
								<NavLink title="Enviar Arquivos" onClick={() => this.openModalUpload()}>
									<span className="menu-icon">
										<i className="ecoico fas fa-cloud-upload-alt" />
									</span>
									<span>Enviar Arquivos</span>
								</NavLink>
							</NavItem>
							{MenuItens.map((item, idx) => (
								<NavItem key={idx}>
									<NavLink
										tag={Link}
										to={item.path}
										title={item.title}
										onClick={() => this.setMenu(item.path)}
										className={`
											darkblue-border-left 
											${this.state.setarMenu === item.path
												? 'active'
												: ''}
										`}>
										<span className="menu-icon">
											<i className={item.ico} />
										</span>
										<span>{item.nome}</span>
										{item.nome === 'Pendentes' && this.state.numGuiasPendentes !== 0 ? (
											<span className="notificacao">{this.state.numGuiasPendentes}</span>
										) : (
											''
										)}
									</NavLink>
								</NavItem>
							))}

							<MenuXLSX />

							{(administrador || vendas) &&
								MenuItensAdministrativos.map((item, idx) => (
									<NavItem key={idx}>
										<NavLink
											tag={Link}
											to={item.path}
											title={item.nome}
											onClick={() => this.setMenu(item.path)}
											className={
												this.state.setarMenu === item.path
													? 'darkblue-border-left active'
													: 'darkblue-border-left'
											}>
											<span className="menu-icon">
												<i className={item.ico} />
											</span>
											<span>{item.nome}</span>
										</NavLink>
									</NavItem>
								))}

								<MenuLinks />

							<NavItem className="mobile">
								<NavLink title="Suporte Técnico" onClick={() => this.abrirSuporteTecnico()}>
									<span className="menu-icon">
										<i className="fas fa-headset" />
									</span>
									<span>Suporte Técnico</span>
								</NavLink>
							</NavItem>
							<NavItem className="mobile">
								<NavLink title="Deixe a sua opinião" onClick={() => this.ModalFeedback.openModal()}>
									<span className="menu-icon">
										<i className="fas fa-comment-alt" />
									</span>
									<span>Deixe a sua opinião</span>
								</NavLink>
							</NavItem>
						</Nav>
					</Collapse>
				</Navbar>
			</aside>
		);
	}
}

export default MenuBar;
